import { render, staticRenderFns } from "./update-with-file.vue?vue&type=template&id=716aaa38"
import script from "./update-with-file.vue?vue&type=script&lang=js"
export * from "./update-with-file.vue?vue&type=script&lang=js"
import style0 from "./update-with-file.vue?vue&type=style&index=0&id=716aaa38&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports